import React, { useEffect, useState } from "react";
import {
  neutral,
  primaryColor,
  theme,
} from "../../../constants/colorConstants";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  Badge,
  Divider,
  MenuItem,
  Select,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Input,
  Checkbox,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  OutlinedInput,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogContent,
  Tab,
  FormGroup,
} from "@mui/material";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "./DataCollectionViewV2.scss";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import {
  getSupplierAllocationPreference,
  getSupplierEmissions,
  getSupplierPreferences,
  getTimePeriods,
  submitSupplierEmissions,
  updateEmissionData,
} from "../../../services/srmService";
import {
  bulkUploadService,
  emissionScopeService,
  getAllEmissionsService,
} from "../../../services/emissionService";
import { toastMessage } from "../../../helper";
import moment from "moment";
import CancelIcon from "@mui/icons-material/Cancel";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import { TabContext, TabList, TabPanel } from "@mui/lab";

export default function DataCollectionViewV2() {
  const navigate = useNavigate();
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  const [submittedTimePeriods, setSubmittedTimePeriods] = useState<any>([]);
  enum COLLECTION_STEPS {
    "EMISSIONS" = "Emissions",
    "ALLOCATION_APPROACH" = "Allocation approach",
  }

  const boldValues = ["Total emissions", "Scope 1", "Scope 2", "Scope 3"];
  let data = {
    emissionsLevel: "company",
    approachMethod: "allocation",
    allocationApproach: "production volume",
    isScopeLevel: false,
    isCategoryLevel: false,
    totalProduction: "",
    suppliedCount: "",
    allocatedPercentage: "",
    totalRevenue: "",
    sales: "",
    allocatedTotalEmissions: "",
    allocatedScope1: "",
    allocatedScope2: "",
    allocatedScope3: "",
    totalEmissions: "",
    totalScope1: "",
    totalScope2: "",
    totalScope3: "",
    emissionTransactions: [
      {
        fieldName: "Total emissions",
        value: "",
        attachments: [],
        comments: "",
        id: null,
      },
    ],
    investorAllocations: [],
    productTransactions: [
      {
        fieldName: "",
        emissionFactor: "",
        totalUnits: "",
        value: "",
        attachments: [],
        comments: "",
        id: null,
      },
    ],
  };
  let [submittedCategoriesMap, setSubmittedCategoriesMap] = useState<any>({});
  let [formData, setFormData] = useState<any>(JSON.parse(JSON.stringify(data)));
  const addNewProduct = () => {
    formData.productTransactions.push({
      fieldName: "",
      emissionFactor: "",
      totalUnits: "",
      value: "",
      attachments: [],
      comments: "",
      id: null,
    });
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  let [showFileUpload, setShowFileUpload] = useState(false);
  const handleClose = () => {
    setShowFileUpload(false);
  };

  enum DIALOG_WARNING_TEXT {
    PREFERENCE = "Would you like to update your preferences from earlier?",
    EMISSIONS = "Modifying the emissions data may impact the accuracy of calculations and lead to inconsistencies.",
  }
  let [dialogWarningText, setDialogWarningText] = useState("");

  const setApproachMethod = (method: string) => {
    if (showPreferenceWarning) {
      setDialogWarningText(DIALOG_WARNING_TEXT.PREFERENCE);
      setOpenWarningDialog(true);
      return;
    }
    formData.approachMethod = method;
    if (method == "product") {
      formData.productTransactions = [
        {
          fieldName: "",
          emissionFactor: "",
          totalUnits: "",
          value: "",
          attachments: [],
          comments: "",
          id: null,
        },
      ];
      formData.allocationApproach = "";
    } else if (method == "none") {
      formData.allocatedTotalEmissions = "";
      formData.allocatedScope1 = "";
      formData.allocatedScope2 = "";
      formData.allocatedScope3 = "";
      formData.totalProduction = "";
      formData.suppliedCount = "";
      formData.allocatedPercentage = "";
      formData.totalRevenue = "";
      formData.sales = "";
      formData.productTransactions = [];
    } else {
      formData.productTransactions = [];
    }
    setFormData(JSON.parse(JSON.stringify(formData)));
  };
  const setAllocationApproach = (allocationApproach: string) => {
    if (showPreferenceWarning) {
      setDialogWarningText(DIALOG_WARNING_TEXT.PREFERENCE);
      setOpenWarningDialog(true);
      return;
    }
    formData.allocationApproach = allocationApproach;
    formData.allocatedTotalEmissions = "";
    formData.allocatedScope1 = "";
    formData.allocatedScope2 = "";
    formData.allocatedScope3 = "";
    formData.totalProduction = "";
    formData.suppliedCount = "";
    formData.allocatedPercentage = "";
    formData.totalRevenue = "";
    formData.sales = "";
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  const handleAllocatedPercentage = (e: any) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    formData.allocatedPercentage = Number(Number(e.target.value).toFixed(6));

    allocateEmissions(
      Number((parseFloat(e.target.value) / 100).toFixed(6)),
      formData
    );
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  const handleInvestorAllocatedPercentage = (e: any, index: any) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    formData.investorAllocations[index].allocatedPercentage = Number(
      Number(e.target.value).toFixed(6)
    );
    allocateEmissions(
      Number((parseFloat(e.target.value) / 100).toFixed(6)),
      formData.investorAllocations[index]
    );
    setFormData(JSON.parse(JSON.stringify(formData)));
  };
  const allocateEmissions = (allocatedRatio: number, allocationObject: any) => {
    allocationObject.allocatedTotalEmissions = Number(
      (formData.totalEmissions * allocatedRatio).toFixed(6)
    );
    if (formData.totalScope1) {
      allocationObject.allocatedScope1 = Number(
        (formData.totalScope1 * allocatedRatio).toFixed(6)
      );
    }
    if (formData.totalScope2) {
      allocationObject.allocatedScope2 = Number(
        (formData.totalScope2 * allocatedRatio).toFixed(6)
      );
    }
    if (formData.totalScope3) {
      allocationObject.allocatedScope3 = Number(
        (formData.totalScope3 * allocatedRatio).toFixed(6)
      );
    }
  };

  const removeEmissions = () => {
    formData.allocatedTotalEmissions = "";
    formData.allocatedScope1 = "";
    formData.allocatedScope2 = "";
    formData.allocatedScope3 = "";
    formData.totalScope1 = "";
    formData.totalScope2 = "";
    formData.totalScope3 = "";
    formData.totalEmissions = "";
  };

  useEffect(() => {
    if (formData.approachMethod === "allocation") {
      if (formData.allocationApproach === "production volume") {
        if (formData.totalProduction && formData.suppliedCount) {
          let suppliedRatio =
            parseFloat(formData.suppliedCount) /
            parseFloat(formData.totalProduction);
          allocateEmissions(suppliedRatio, formData);
        }
      } else if (formData.allocationApproach === "fixed percentage") {
        if (formData.allocatedPercentage) {
          allocateEmissions(
            parseFloat(formData.allocatedPercentage) / 100,
            formData
          );
        }
      } else if (formData.allocationApproach === "economic") {
        if (formData.totalRevenue && formData.sales) {
          let revenueRatio =
            parseFloat(formData.sales) / parseFloat(formData.totalRevenue);
          allocateEmissions(revenueRatio, formData);
        }
      }
      setFormData(JSON.parse(JSON.stringify(formData)));
    }
  }, [formData.totalEmissions, formData.totalScope1, formData.totalScope2]);

  const enableScopeLevel = (event: any) => {
    removeEmissions();
    formData.isScopeLevel = event.checked;
    if (event.checked) {
      formData.emissionTransactions = [
        ...["Total emissions", "Scope 1", "Scope 2", "Scope 3"].map((scope) => {
          return {
            fieldName: scope,
            value: "",
            attachments: [],
            comments: "",
            id: null,
          };
        }),
      ];
      formData.emissionTransactions.forEach((transaction: any) => {
        if (submittedCategoriesMap[transaction.fieldName]) {
          transaction.value = submittedCategoriesMap[transaction.fieldName];
        }
      });
      formData.totalEmissions = submittedCategoriesMap["Total emissions"];
      formData.totalScope1 = submittedCategoriesMap["Scope 1"];
      formData.totalScope2 = submittedCategoriesMap["Scope 2"];
      formData.totalScope3 = submittedCategoriesMap["Scope 3"];
    } else {
      formData.isCategoryLevel = false;
      formData.emissionTransactions = [
        ...["Total emissions"].map((scope) => {
          return {
            fieldName: scope,
            value: "",
            attachments: [],
            comments: "",
            id: null,
          };
        }),
      ];
      formData.emissionTransactions.forEach((transaction: any) => {
        if (submittedCategoriesMap[transaction.fieldName]) {
          transaction.value = submittedCategoriesMap[transaction.fieldName];
        }
      });
      formData.totalEmissions = submittedCategoriesMap["Total emissions"];
    }
    setFormData(JSON.parse(JSON.stringify(formData)));
  };
  const enableCategoryLevel = (event: any) => {
    removeEmissions();
    if (event.checked) {
      formData.isScopeLevel = true;
      formData.emissionTransactions = [
        {
          fieldName: "Total emissions",
          value: "",
          attachments: [],
          comments: "",
          id: null,
        },
        ...scopeMap.scope1.map((category) => {
          return {
            fieldName: category,
            value: "",
            attachments: [],
            comments: "",
            id: null,
          };
        }),
        ...scopeMap.scope2.map((category) => {
          return {
            fieldName: category,
            value: "",
            attachments: [],
            comments: "",
            id: null,
          };
        }),
        ...scopeMap.scope3.map((category) => {
          return {
            fieldName: category,
            value: "",
            attachments: [],
            comments: "",
            id: null,
          };
        }),
      ];
      formData.isCategoryLevel = true;
      formData.emissionTransactions.forEach((transaction: any) => {
        if (submittedCategoriesMap[transaction.fieldName]) {
          transaction.value = submittedCategoriesMap[transaction.fieldName];
        }
      });
      formData.totalEmissions = submittedCategoriesMap["Total emissions"];
      formData.totalScope1 = submittedCategoriesMap["Scope 1"];
      formData.totalScope2 = submittedCategoriesMap["Scope 2"];
      formData.totalScope3 = submittedCategoriesMap["Scope 3"];
      setFormData(JSON.parse(JSON.stringify(formData)));
    } else {
      formData.isCategoryLevel = false;
      enableScopeLevel({ checked: true });
    }
  };

  const handleCancel = () => {
    navigate("/partners/customers/list");
  };

  const handleSubmit = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const company = JSON.parse(localStorage.getItem("company") || "{}");
    if (emissionsData) {
      return;
      emissionsData.emissions_level = formData.emissionsLevel;
      emissionsData.approach_method = formData.approachMethod;
      emissionsData.allocation_approach = formData.allocationApproach;
      emissionsData.is_scope_level = formData.isScopeLevel;
      emissionsData.is_category_level = formData.isCategoryLevel;
      emissionsData.total_production = formData.totalProduction;
      emissionsData.supplied_count = formData.suppliedCount;
      emissionsData.allocated_percentage = formData.allocatedPercentage;
      emissionsData.total_revenue = formData.totalRevenue;
      emissionsData.sales = formData.sales;
      emissionsData.allocated_total_emissions =
        formData.allocatedTotalEmissions;
      emissionsData.allocated_scope1 = formData.allocatedScope1;
      emissionsData.allocated_scope2 = formData.allocatedScope2;
      emissionsData.allocated_scope3 = formData.allocatedScope3;
      emissionsData.total_emissions = formData.totalEmissions;
      emissionsData.total_scope1 = formData.totalScope1;
      emissionsData.total_scope2 = formData.totalScope2;
      emissionsData.total_scope3 = formData.totalScope3;

      emissionsData.transactions.forEach((item: any) => {
        let emissionFilterArray = formData.emissionTransactions.filter(
          (transaction: any) => transaction.id == item.id
        );
        if (emissionFilterArray.length) {
          let obj = emissionFilterArray[0];
          item.value = obj.value;
          item.attachments = obj.attachments;
          item.comments = obj.comments;
        } else {
          let productFilterArray = formData.productTransactions.filter(
            (transaction: any) => transaction.id == item.id
          );
          let obj = productFilterArray[0];
          item.value = obj.value;
          item.field_name = obj.fieldName;
          item.attachments = obj.attachments;
          item.comments = obj.comments;
          item.emission_factor = obj.emissionFactor;
          item.total_units = obj.totalUnits;
        }
      });

      updateEmissionData(emissionsData).then((res) => {
        setEmissionData(null);
        toastMessage("Data updated successfully", "success");
        goToCustomerList();
      });
    } else {
      formData["company"] = company.id;
      formData["fromDate"] = timePeriod.fromDate;
      formData["toDate"] = timePeriod.toDate;
      formData["customer"] = searchParams.get("customer");
      formData["transactions"] = [...formData.emissionTransactions];
      if (formData["approachMethod"] == "product") {
        formData["transactions"] = [
          ...formData["transactions"],
          ...formData.productTransactions,
        ];
      }
      submitSupplierEmissions(formData).then((res) => {
        toastMessage("Data added successfully", "success");
        goToCustomerList();
      });
    }
  };
  const goToCustomerList = () => {
    navigate("/partners/customers/list");
  };
  let [categoryMap, setCategoryMap] = useState<any>();
  let [scopeMap, setScopeMap] = useState({
    scope1: [""],
    scope2: [""],
    scope3: [""],
  });
  useEffect(() => {
    emissionScopeService().then((data) => {
      if (data.status == 200) {
        scopeMap.scope3.pop();
        categoryMap = {};
        data.data.forEach((el: any) => {
          el.categories.forEach((category: any) => {
            categoryMap[
              category.code + " " + category.name
            ] = `Scope ${el.scope}`;
          });
          if (el.scope == 1 || el.scope == 70) {
            scopeMap.scope1.shift();
            scopeMap.scope1 = [
              "Scope 1",
              ...scopeMap.scope1,
              ...el.categories.map(
                (category: any) => category.code + " " + category.name
              ),
            ];
          } else if (el.scope == 2 || el.scope == 71) {
            scopeMap.scope2.shift();
            scopeMap.scope2 = [
              "Scope 2",
              ...scopeMap.scope2,
              ...el.categories.map(
                (category: any) => category.code + " " + category.name
              ),
            ];
          } else if (el.scope == 3 || el.scope == 72) {
            scopeMap.scope3.shift();
            scopeMap.scope3 = [
              "Scope 3",
              ...scopeMap.scope3,
              ...el.categories.map(
                (category: any) => category.code + " " + category.name
              ),
            ];
          }
        });
        setScopeMap(JSON.parse(JSON.stringify(scopeMap)));
        setCategoryMap(JSON.parse(JSON.stringify(categoryMap)));
      }
    });
    const searchParams = new URLSearchParams(window.location.search);
    getSupplierPreferences(searchParams.get("customer")).then((data) => {
      if (data.status == 200) {
        setPreferences(data.data);
        if (!data.data.is_supplier) {
          setAllocationTabValue("2");
        }
        let prefs = data.data;
        if (true || prefs.frequency == "Monthly") {
          setTimePeriod({
            fromDate: moment().startOf("month").toISOString(),
            toDate: moment().endOf("month").toISOString(),
          });
        } else if (prefs.frequency == "Yearly") {
          setTimePeriod({
            fromDate: moment().startOf("year").toISOString(),
            toDate: moment().endOf("year").toISOString(),
          });
        } else if (prefs.frequency == "Quarterly") {
          setTimePeriod({
            fromDate: moment().startOf("quarter").toISOString(),
            toDate: moment().endOf("quarter").toISOString(),
          });
        }
      }
    });
  }, []);

  let [preferences, setPreferences] = useState<any>(null);

  const handleTotalProduction = (e: any) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    formData.totalProduction = e.target.value;
    if (formData.suppliedCount) {
      if (Number(formData.totalProduction) < Number(formData.suppliedCount)) {
        toastMessage(
          "Total Production should not be less than supplied count",
          "error"
        );
        return;
      }
      if (formData.totalEmissions) {
        let suppliedRatio =
          parseFloat(formData.suppliedCount) /
          parseFloat(formData.totalProduction);
        allocateEmissions(suppliedRatio, formData);
      }
    }
    setFormData(JSON.parse(JSON.stringify(formData)));
  };
  // const handleTransactionNumberInput = (transaction:any,value:string,fieldName:string)=>{
  //   if(isNotNaN(value)){
  //       handleTransactionTextInput(transaction,value,fieldName);
  //   }
  // }

  const [allocationTabValue, setAllocationTabValue] = useState("1");
  const handleAllocationTabChange = (e: any, value: any) => {
    setAllocationTabValue(value);
  };

  const isNotNaN = (value: string) => {
    if (isNaN(Number(value)) && value != "") {
      return false;
    }
    return true;
  };

  const handlesuppliedCount = (e: any) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    if (formData.totalProduction) {
      if (Number(formData.totalProduction) < Number(e.target.value)) {
        toastMessage(
          "Supplied count can't be greater than total production",
          "error"
        );
        return;
      }
      formData.suppliedCount = e.target.value;
      if (formData.totalEmissions) {
        let suppliedRatio =
          parseFloat(formData.suppliedCount) /
          parseFloat(formData.totalProduction);
        allocateEmissions(suppliedRatio, formData);
      }
      setFormData(JSON.parse(JSON.stringify(formData)));
    } else {
      toastMessage("Please provide total production", "error");
      return;
    }
  };

  let [showWarning, setShowWarning] = useState(false);
  let [showPreferenceWarning, setShowPreferenceWarning] = useState(false);
  const setEmissionValue = (transaction: any, emissionValue: string) => {
    if (showWarning) {
      setDialogWarningText(DIALOG_WARNING_TEXT.EMISSIONS);
      setOpenWarningDialog(true);
      return;
    }
    if (isNaN(Number(emissionValue)) && emissionValue != "") return;
    if (formData.isScopeLevel) {
      let total = formData.emissionTransactions.filter(
        (el: any) => el.fieldName === "Total emissions"
      );
      total[0].value = Number(
        (
          Number(total[0].value) -
          Number(transaction.value) +
          Number(emissionValue)
        ).toFixed(6)
      ).toString();
      formData.totalEmissions = total[0].value;
      if (formData.isCategoryLevel) {
        let scope = formData.emissionTransactions.filter(
          (el: any) => el.fieldName === categoryMap[transaction.fieldName]
        );
        scope[0].value = Number(
          (
            Number(scope[0].value) -
            Number(transaction.value) +
            Number(emissionValue)
          ).toFixed(6)
        ).toString();
        let key = `total${scope[0].fieldName.replace(" ", "")}`;
        formData[key] = scope[0].value;
      }
      if (["Scope 1", "Scope 2", "Scope 3"].includes(transaction.fieldName)) {
        let key = `total${transaction.fieldName.replace(" ", "")}`;
        formData[key] = emissionValue;
      }
    }
    transaction.value = emissionValue;
    if (transaction.fieldName == "Total emissions") {
      formData.totalEmissions = emissionValue;
    }
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  const isInputRequired = (transaction: any) => {
    if (formData.isScopeLevel) {
      if (transaction.fieldName == "Total emissions") return false;
      if (formData.isCategoryLevel)
        return !["Scope 1", "Scope 2", "Scope 3"].includes(
          transaction.fieldName
        );
    }
    return true;
  };

  // const handleFileUpload = (e: any, transaction: any) => {
  //   // let obj = getObjectFromPath(pathString);
  //   const promiseList: any[] = [];
  //   Array.from(e.target.files).forEach((file: any) => {
  //     const uploadData = new FormData();
  //     uploadData.append("file", file);
  //     promiseList.push(
  //       new Promise((resolve, reject) => {
  //         bulkUploadService(uploadData).then((res) => {
  //           resolve({ url: res.data.Location });
  //         });
  //       })
  //     );
  //   });
  //   Promise.all(promiseList).then((values) => {
  //     console.log(values);
  //     transaction["attachments"] = values;
  //     setFormData(JSON.parse(JSON.stringify(formData)));
  //   });
  // };

  const handleFileUpload = (attachments: any) => {
    currentAttachmentForm["attachments"] = attachments;
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  let [currentAttachmentForm, setCurrentAttachmentForm] = useState<any>({});

  const openAttachments = (transaction: any) => {
    setCurrentAttachmentForm(transaction);
    setShowFileUpload(true);
  };

  const handleEmissionFactor = (transaction: any, e: any) => {
    if (isNotNaN(e.target.value)) {
      if (transaction.totalUnits) {
        formData.allocatedTotalEmissions = Number(
          (
            formData.allocatedTotalEmissions -
            transaction.totalUnits * transaction.emissionFactor +
            transaction.totalUnits * e.target.value
          ).toFixed(6)
        );
        transaction.value = Number(
          (transaction.totalUnits * e.target.value).toFixed(6)
        );
      }
      handleTransactionTextInput(transaction, e.target.value, "emissionFactor");
    }
  };
  const handleTotalUnits = (transaction: any, e: any) => {
    if (isNotNaN(e.target.value)) {
      if (transaction.emissionFactor) {
        formData.allocatedTotalEmissions = Number(
          (
            formData.allocatedTotalEmissions -
            transaction.totalUnits * transaction.emissionFactor +
            e.target.value * transaction.emissionFactor
          ).toFixed(6)
        );
        transaction.value = Number(
          (transaction.emissionFactor * e.target.value).toFixed(6)
        );
      }
      handleTransactionTextInput(transaction, e.target.value, "totalUnits");
    }
  };

  const handleNext = () => {
    setStep(COLLECTION_STEPS.ALLOCATION_APPROACH);
  };

  const handleTransactionTextInput = (
    transaction: any,
    value: string,
    fieldName: string
  ) => {
    transaction[fieldName] = value;
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  let [step, setStep] = useState(COLLECTION_STEPS.EMISSIONS);
  const trigger = () => {
    const searchParams = new URLSearchParams(window.location.search);
    setTimeout(() => {
      getTimePeriods(
        document.querySelector(".ant-picker-year-btn")?.innerHTML || "",
        company.id,
        Number(searchParams.get("customer"))
      ).then((res) => {
        setSubmittedTimePeriods(
          res.data && res.data
            ? res.data.time_periods.map((e: any) => new Date(e).toISOString())
            : []
        );
      });
    }, 100);
  };

  let [emissionsData, setEmissionData] = useState<any>(null);

  const handleRevenue = (e: any) => {
    if (isNotNaN(e.target.value)) {
      if (formData.sales) {
        allocateEmissions(
          parseFloat(formData.sales) / parseFloat(e.target.value),
          formData
        );
      }
      handleTransactionTextInput(formData, e.target.value, "totalRevenue");
    }
  };
  const handleSales = (e: any) => {
    if (isNotNaN(e.target.value)) {
      if (formData.totalRevenue) {
        allocateEmissions(
          parseFloat(e.target.value) / parseFloat(formData.totalRevenue),
          formData
        );
      }
      handleTransactionTextInput(formData, e.target.value, "sales");
    }
  };

  const fillForm = (apiData: any) => {
    let tempData = {
      emissionsLevel: apiData.emission_level,
      approachMethod: apiData.approach_method,
      allocationApproach: apiData.allocation_approach,
      isScopeLevel: apiData.is_scope_level,
      isCategoryLevel: apiData.is_category_level,
      totalProduction: apiData.total_production,
      suppliedCount: apiData.supplied_count,
      allocatedPercentage: apiData.allocated_percentage,
      totalRevenue: apiData.total_revenue,
      sales: apiData.sales,
      allocatedTotalEmissions: apiData.allocated_total_emissions,
      allocatedScope1: apiData.allocated_scope1,
      allocatedScope2: apiData.allocated_scope2,
      allocatedScope3: apiData.allocated_scope3,
      totalEmissions: apiData.total_emissions,
      totalScope1: apiData.total_scope1,
      totalScope2: apiData.total_scope2,
      totalScope3: apiData.total_scope3,
      emissionTransactions: [
        {
          attachments: [],
          comments: "",
          fieldName: "",
          value: "",
          id: null,
        },
      ],
      productTransactions: [
        {
          fieldName: "",
          emissionFactor: "",
          totalUnits: "",
          value: "",
          attachments: [],
          comments: "",
          id: null,
        },
      ],
      investorAllocations: [{}],
    };
    tempData.emissionTransactions.pop();
    tempData.productTransactions.pop();
    tempData.investorAllocations.pop();
    selectedInvestmentCategories = {
      "Listed equity and corporate bonds": false,
      "Business loans and unlisted equity": false,
      "Project finance": false,
      "Commercial real estate": false,
      Mortgages: false,
      "Motor vehicle loans": false,
      "Sovereign debt": false,
    };
    investmentCategories.forEach((item) => {
      let index = apiData.investorAllocations.findIndex(
        (each: any) => item == each.name
      );
      if (index > -1) {
        selectedInvestmentCategories[apiData.investorAllocations[index].name] =
          true;
        tempData.investorAllocations.push({
          name: apiData.investorAllocations[index].name,
          allocatedTotalEmissions:
            apiData.investorAllocations[index].allocated_total_emissions,
          allocatedScope1: apiData.investorAllocations[index].allocated_scope1,
          allocatedScope2: apiData.investorAllocations[index].allocated_scop2,
          allocatedScope3: apiData.investorAllocations[index].allocated_scope3,
          allocationMethod:
            apiData.investorAllocations[index].allocation_method,
          numerator: apiData.investorAllocations[index].numerator,
          denominator: apiData.investorAllocations[index].denominator,
          allocatedPercentage:
            apiData.investorAllocations[index].allocated_percentage,
        });
      }
    });
    setSelectedInvestmentCategories({ ...selectedInvestmentCategories });
    tempData.emissionTransactions = apiData.transactions
      .filter((transaction: any) => transaction["emission_factor"] == null)
      .map((eachTransaction: any) => {
        return {
          fieldName: eachTransaction.field_name,
          value: eachTransaction.value,
          attachments: eachTransaction.attachments,
          comments: eachTransaction.comments,
          id: eachTransaction.id,
        };
      });
    tempData.productTransactions = apiData.transactions
      .filter((transaction: any) => transaction["emission_factor"] != null)
      .map((eachTransaction: any) => {
        return {
          fieldName: eachTransaction.field_name,
          emissionFactor: eachTransaction.emission_factor,
          totalUnits: eachTransaction.total_units,
          value: eachTransaction.value,
          attachments: eachTransaction.attachments,
          comments: eachTransaction.comments,
          id: eachTransaction.id,
        };
      });
    setFormData(JSON.parse(JSON.stringify(tempData)));
  };

  let [timePeriod, setTimePeriod] = useState({
    fromDate: moment().startOf("month").toISOString(),
    toDate: moment().endOf("month").toISOString(),
  });

  const resetForm = () => {
    formData = JSON.parse(JSON.stringify(data));
    submittedCategoriesMap = {};
    let token: any = localStorage.getItem("token");
    let userRole = JSON.parse(atob(token?.split(".")[1])).iss.role;
    if (userRole != 5) {
      getAllEmissionsService({
        from_date: moment(timePeriod.fromDate).startOf("month").toISOString(),
        to_date: moment(timePeriod.toDate).endOf("month").toISOString(),
      })
        .then((res: any) => {
          let preSubmittedEmissions = res.data;
          if (preSubmittedEmissions.length) {
            setShowWarning(true);
            submittedCategoriesMap["Total emissions"] = 0;
            preSubmittedEmissions.forEach((submittedEmission: any) => {
              if (localStorage.getItem("protocol") == "iso") {
                submittedCategoriesMap[submittedEmission.code] = Number(
                  (submittedEmission.value / 1000).toFixed(6)
                );
                submittedCategoriesMap["Total emissions"] = Number(
                  (
                    submittedCategoriesMap["Total emissions"] +
                    submittedCategoriesMap[submittedEmission.code]
                  ).toFixed(6)
                );
              }
              submittedEmission.categories.forEach((categoriesData: any) => {
                if (localStorage.getItem("protocol") == "ghg") {
                  submittedCategoriesMap[categoriesData.code] = Number(
                    (categoriesData.value / 1000).toFixed(6)
                  );
                  submittedCategoriesMap["Total emissions"] = Number(
                    (
                      submittedCategoriesMap["Total emissions"] +
                      submittedCategoriesMap[categoriesData.code]
                    ).toFixed(6)
                  );
                }
                categoriesData.subcategories.forEach((subCategory: any) => {
                  submittedCategoriesMap[
                    subCategory.code + " " + subCategory.name
                  ] = Number((subCategory.value / 1000).toFixed(6));
                });
              });
            });
            formData.emissionTransactions[0].value =
              submittedCategoriesMap["Total emissions"];
            formData.totalEmissions = submittedCategoriesMap["Total emissions"];
          } else {
            setShowWarning(false);
          }
        })
        .catch((e) => {
          setShowWarning(false);
          console.log(e);
        })
        .finally(() => {
          setEmissionsAndPopulatePreferences();
        });
    } else {
      setShowWarning(false);
      setEmissionsAndPopulatePreferences();
    }
  };

  const setEmissionsAndPopulatePreferences = () => {
    setSubmittedCategoriesMap(submittedCategoriesMap);
    setEmissionData(null);
    populatePreferences();
  };

  const setInvestorAllocationApproach = (value: any, index: any) => {
    formData.investorAllocations[index].allocationMethod = value;
    formData.investorAllocations[index].numerator = "";
    formData.investorAllocations[index].denominator = "";
    formData.investorAllocations[index].allocatedPercentage = "";
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  const handleAllocationCategoryCheck = (
    name: string,
    index: number,
    e: any
  ) => {
    if (e.target.checked) {
      formData.investorAllocations.splice(index, 0, {
        name: name,
        allocatedTotalEmissions: "",
        allocatedScope1: "",
        allocatedScope2: "",
        allocatedScope3: "",
        allocationMethod: "",
        numerator: "",
        denominator: "",
        allocatedPercentage: "",
      });
      selectedInvestmentCategories[name] = true;
    } else {
      let removeIndex = formData.investorAllocations.findIndex(
        (item: any) => item.name == name
      );
      formData.investorAllocations.splice(removeIndex, 1);
      selectedInvestmentCategories[name] = false;
    }
    setSelectedInvestmentCategories({ ...selectedInvestmentCategories });
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  let [investmentCategories, setInvestmentCategories] = useState([
    "Listed equity and corporate bonds",
    "Business loans and unlisted equity",
    "Project finance",
    "Commercial real estate",
    "Mortgages",
    "Motor vehicle loans",
    "Sovereign debt",
  ]);

  let [selectedInvestmentCategories, setSelectedInvestmentCategories] =
    useState<any>({
      "Listed equity and corporate bonds": false,
      "Business loans and unlisted equity": false,
      "Project finance": false,
      "Commercial real estate": false,
      Mortgages: false,
      "Motor vehicle loans": false,
      "Sovereign debt": false,
    });

  const populatePreferences = () => {
    const searchParams = new URLSearchParams(window.location.search);
    getSupplierAllocationPreference(searchParams.get("customer"))
      .then((res) => {
        if (res.data) {
          formData.isCategoryLevel = res.data.is_category_level;
          formData.isScopeLevel = res.data.is_scope_level;
          formData.emissionsLevel = res.data.emissions_level;
          formData.allocationApproach = res.data.allocation_approach;
          formData.approachMethod = res.data.approach_method;
          if (res.data.products && res.data.products.length) {
            formData.productTransactions = [];
            for (let product of res.data.products) {
              formData.productTransactions.push({
                fieldName: product,
                emissionFactor: "",
                totalUnits: "",
                value: "",
                attachments: [],
                comments: "",
                id: null,
              });
            }
          }
          setShowPreferenceWarning(true);
          if (formData.isCategoryLevel) {
            enableCategoryLevel({ checked: true });
          } else if (formData.isScopeLevel) {
            enableScopeLevel({ checked: true });
          } else {
            setFormData(JSON.parse(JSON.stringify(formData)));
          }
        } else {
          setShowPreferenceWarning(false);
          setFormData(JSON.parse(JSON.stringify(formData)));
        }
      })
      .catch((e) => {
        console.log(e);
        setShowPreferenceWarning(false);
        setFormData(JSON.parse(JSON.stringify(formData)));
      });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    getTimePeriods(
      new Date(timePeriod.fromDate).getFullYear().toString(),
      company.id,
      Number(searchParams.get("customer"))
    ).then((res) => {
      setSubmittedTimePeriods(
        res.data && res.data.time_periods
          ? res.data.time_periods?.map((e: any) => new Date(e).toISOString())
          : []
      );
      let intervals =
        res.data && res.data.time_periods
          ? res.data.time_periods.map((e: any) => new Date(e).toISOString())
          : [];
      setSelectedInvestmentCategories({
        "Listed equity and corporate bonds": false,
        "Business loans and unlisted equity": false,
        "Project finance": false,
        "Commercial real estate": false,
        Mortgages: false,
        "Motor vehicle loans": false,
        "Sovereign debt": false,
      });
      if (intervals.includes(timePeriod.fromDate)) {
        //fetch timeperiod data
        getSupplierEmissions(
          timePeriod.fromDate,
          company.id,
          Number(searchParams.get("customer")),
          timePeriod.toDate
        ).then((emissionRes) => {
          console.log(emissionRes.data);
          setEmissionData(emissionRes.data);
          fillForm(emissionRes.data);
        });
      } else {
        resetForm();
      }
    });
  }, [timePeriod]);
  let [currentActiveDate, setCurrentActiveDate] = useState(
    dayjs(timePeriod.fromDate)
  );
  const handleInvestorDenominator = (e: any, index: any) => {
    formData.investorAllocations[index].denominator = e.target.value;
    if (formData.investorAllocations[index].numerator) {
      allocateEmissions(
        formData.investorAllocations[index].numerator /
          formData.investorAllocations[index].denominator,
        formData.investorAllocations[index]
      );
    }
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  const handleInvestorNumerator = (e: any, index: any) => {
    formData.investorAllocations[index].numerator = e.target.value;
    if (formData.investorAllocations[index].denominator) {
      allocateEmissions(
        formData.investorAllocations[index].numerator /
          formData.investorAllocations[index].denominator,
        formData.investorAllocations[index]
      );
    }
    setFormData(JSON.parse(JSON.stringify(formData)));
  };

  const onTimePeriodChange = (e: any) => {
    let fromDate = e.$d.toISOString();
    let toDate = "";
    if (true || preferences.frequency == "Monthly") {
      fromDate = moment(new Date(fromDate)).startOf("month").toISOString();
      toDate = moment(new Date(fromDate)).endOf("month").toISOString();
    } else if (preferences.frequency == "Quarterly") {
      fromDate = moment(new Date(fromDate)).startOf("quarter").toISOString();
      toDate = moment(new Date(fromDate)).endOf("quarter").toISOString();
    } else if (preferences.frequency == "Yearly") {
      fromDate = moment(new Date(fromDate)).startOf("year").toISOString();
      toDate = moment(new Date(fromDate)).endOf("year").toISOString();
    }
    // let split = e.$d.toDateString().split(" ");
    setCurrentActiveDate(dayjs(fromDate));
    setTimePeriod({ fromDate, toDate });
  };
  let [openWarningDialog, setOpenWarningDialog] = useState(false);
  return (
    <div className="flex pw-data-creation-form">
      <div className="w-1/5" style={{ background: neutral[200] }}>
        <div
          onClick={(e) => {
            setStep(COLLECTION_STEPS.EMISSIONS);
          }}
          className={`pw-cursor-pointer pw-org-side-elem ${
            COLLECTION_STEPS.EMISSIONS == step ? "pw-step-active" : ""
          }`}
        >
          Emissions
        </div>
        <div
          onClick={(e) => {
            setStep(COLLECTION_STEPS.ALLOCATION_APPROACH);
          }}
          className={`pw-org-side-elem pw-cursor-pointer ${
            COLLECTION_STEPS.ALLOCATION_APPROACH == step ? "pw-step-active" : ""
          }`}
        >
          Allocation approach
        </div>
      </div>
      <div className="w-4/5 pw-data-form" style={{ background: neutral[100] }}>
        <div style={{ padding: "50px", marginBottom: "50px" }}>
          {step == COLLECTION_STEPS.EMISSIONS ? (
            <>
              <div>
                <p style={{ fontSize: "1.3rem", marginBottom: "10px" }}>
                  <strong>Emissions</strong>
                </p>
                <p style={{ color: "#3D4A5D", marginBottom: "5px" }}>
                  Provide your total emissions{" "}
                </p>
                <Divider
                  sx={{
                    borderColor: theme.palette.grey[400],
                    paddingTop: "1rem",
                  }}
                />
              </div>

              <div
                style={{ marginTop: "30px" }}
                className="flex flex-row gap-8 items-center"
              >
                {true || preferences?.frequency == "Monthly" ? (
                  <DatePicker
                    allowClear={false}
                    format={"MMM YYYY"}
                    disabledDate={(d) => !d || d.isAfter(dayjs())}
                    defaultValue={dayjs(
                      new Date().toISOString().split("T")[0],
                      "YYYY-MM-DD"
                    )}
                    value={currentActiveDate}
                    superNextIcon={<ArrowForwardIosIcon onClick={trigger} />}
                    superPrevIcon={<ArrowBackIosIcon onClick={trigger} />}
                    cellRender={(current, { originNode }) => {
                      return submittedTimePeriods.includes(
                        moment(current.toDate()).startOf("month").toISOString()
                      ) || current.toDate() > new Date() ? (
                        originNode
                      ) : (
                        <Badge color="info" variant="dot">
                          <span>{originNode}</span>
                        </Badge>
                      );
                    }}
                    onChange={onTimePeriodChange}
                    picker="month"
                  />
                ) : preferences?.frequency == "Quarterly" ? (
                  <DatePicker
                    allowClear={false}
                    disabledDate={(d) => !d || d.isAfter(dayjs())}
                    defaultValue={dayjs(
                      new Date().toISOString().split("T")[0],
                      "YYYY-MM-DD"
                    )}
                    superNextIcon={<ArrowForwardIosIcon onClick={trigger} />}
                    superPrevIcon={<ArrowBackIosIcon onClick={trigger} />}
                    cellRender={(current, { originNode }) => {
                      return submittedTimePeriods.includes(
                        current.toDate().toISOString()
                      ) || current.toDate() > new Date() ? (
                        originNode
                      ) : (
                        <Badge color="info" variant="dot">
                          <span>{originNode}</span>
                        </Badge>
                      );
                    }}
                    onChange={onTimePeriodChange}
                    picker="quarter"
                  />
                ) : preferences?.frequency == "Yearly" ? (
                  <DatePicker
                    allowClear={false}
                    format={"YYYY"}
                    disabledDate={(d) => !d || d.isAfter(dayjs())}
                    defaultValue={dayjs(
                      new Date().toISOString().split("T")[0],
                      "YYYY-MM-DD"
                    )}
                    superNextIcon={<ArrowForwardIosIcon onClick={trigger} />}
                    superPrevIcon={<ArrowBackIosIcon onClick={trigger} />}
                    cellRender={(current, { originNode }) => {
                      return submittedTimePeriods.includes(
                        current.toDate().toISOString()
                      ) || current.toDate() > new Date() ? (
                        originNode
                      ) : (
                        <Badge color="info" variant="dot">
                          <span>{originNode}</span>
                        </Badge>
                      );
                    }}
                    onChange={onTimePeriodChange}
                    picker="year"
                  />
                ) : (
                  ""
                )}
                <div style={{ color: "#3D4A5D" }} className="text-sm">
                  Data request frequency: {preferences?.frequency}
                </div>
              </div>

              <div
                style={{
                  padding: "30px",
                  background: "white",
                  borderRadius: "5px",
                  marginTop: "30px",
                }}
              >
                <p
                  style={{
                    color: neutral[500],
                    fontSize: "0.9rem",
                    marginBottom: "30px",
                  }}
                >
                  <strong>EMISSIONS</strong>
                </p>
                <div className="flex items-center gap-x-8">
                  {/* <Select sx={{ width: "20%", fontSize: "0.9rem", borderRadius: "10px" }} value="Total Emissions">
                    <MenuItem value={"Total Emissions"}>Total Emissions</MenuItem>
                  </Select> */}
                  <div>
                    <Checkbox
                      disabled={!!emissionsData}
                      onChange={(e) => {
                        enableScopeLevel(e.target);
                      }}
                      checked={formData.isScopeLevel}
                      color="primary"
                    />
                    Scope level
                  </div>
                  <div>
                    <Checkbox
                      disabled={!!emissionsData}
                      onChange={(e) => {
                        enableCategoryLevel(e.target);
                      }}
                      checked={formData.isCategoryLevel}
                      color="primary"
                    />{" "}
                    Category level
                  </div>
                </div>
                <div>
                  <Table sx={{ marginTop: "30px" }}>
                    <TableHead sx={{ backgroundColor: "#FAFBFD" }}>
                      <TableRow>
                        <TableCell>Parameters</TableCell>
                        <TableCell sx={{ backgroundColor: "#FDF8E8" }}>
                          Emissions(t Co2e)
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell>Comments</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData.emissionTransactions.map((transaction: any) => {
                        return (
                          <TableRow>
                            <TableCell
                              sx={{
                                backgroundColor: isInputRequired(transaction)
                                  ? "white"
                                  : "#E9F5FD",
                                fontWeight: boldValues.includes(
                                  transaction.fieldName
                                )
                                  ? "800"
                                  : "400",
                                width: "35%",
                              }}
                            >
                              {transaction.fieldName}
                            </TableCell>
                            <TableCell
                              sx={{
                                backgroundColor: isInputRequired(transaction)
                                  ? "#FDF8E8"
                                  : "#E9F5FD",
                                width: "15%",
                              }}
                            >
                              {isInputRequired(transaction) ? (
                                <Input
                                  disabled={!!emissionsData}
                                  value={transaction.value}
                                  onChange={(e) => {
                                    setEmissionValue(
                                      transaction,
                                      e.target.value
                                    );
                                  }}
                                />
                              ) : (
                                transaction.value
                              )}
                            </TableCell>
                            <TableCell>
                              {" "}
                              <label
                                className="pw-cursor-pointer"
                                htmlFor={transaction.fieldName}
                              >
                                <Badge
                                  onClick={(e) => openAttachments(transaction)}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  className={
                                    transaction.attachments.length
                                      ? "pw-badge-primary"
                                      : "pw-badge-disabled"
                                  }
                                  badgeContent={
                                    transaction.attachments.length ? (
                                      transaction.attachments.length
                                    ) : (
                                      <AddIcon />
                                    )
                                  }
                                >
                                  <AttachFileIcon />
                                </Badge>
                              </label>
                              {/* <input
                                disabled={!!emissionsData}
                                multiple
                                className="hidden"
                                onChange={(e) =>
                                  openAttachments(transaction)
                                }
                                id={transaction.fieldName}
                                type="file"
                              /> */}
                            </TableCell>
                            <TableCell>
                              <Input
                                disabled={!!emissionsData}
                                sx={{ width: "90%" }}
                                multiline
                                onChange={(e) =>
                                  handleTransactionTextInput(
                                    transaction,
                                    e.target.value,
                                    "comments"
                                  )
                                }
                                value={transaction.comments}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </>
          ) : step == COLLECTION_STEPS.ALLOCATION_APPROACH ? (
            <>
              <div>
                <p style={{ fontSize: "1.3rem", marginBottom: "10px" }}>
                  <strong>Approach for emission allocations</strong>
                </p>
                <p style={{ color: "#3D4A5D", marginBottom: "5px" }}>
                  Provide the allocation method and approach{" "}
                </p>
                <Divider
                  sx={{
                    borderColor: theme.palette.grey[400],
                    paddingTop: "1rem",
                  }}
                />
              </div>
              <TabContext value={allocationTabValue}>
                <TabList onChange={handleAllocationTabChange}>
                  {preferences.is_supplier ? (
                    <Tab
                      value="1"
                      sx={{
                        fontWeight:
                          allocationTabValue === "1" ? "bold" : "regular",
                      }}
                      label="C4.1"
                    />
                  ) : (
                    ""
                  )}
                  {preferences.is_borrower ? (
                    <Tab
                      value="2"
                      sx={{
                        fontWeight:
                          allocationTabValue === "2" ? "bold" : "regular",
                      }}
                      label="C5.4-Investments"
                    />
                  ) : (
                    ""
                  )}
                </TabList>
                <TabPanel value="1">
                  <div
                    style={{
                      padding: "30px",
                      background: "white",
                      borderRadius: "5px",
                      // marginTop: "30px",
                    }}
                  >
                    <p
                      style={{
                        color: neutral[500],
                        fontSize: "0.9rem",
                        marginBottom: "30px",
                      }}
                    >
                      <strong>ALLOCATION</strong>
                    </p>
                    <RadioGroup
                      onChange={(e) => setApproachMethod(e.target.value)}
                      value={formData.approachMethod}
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        disabled={!!emissionsData}
                        value="product"
                        control={<Radio />}
                        label="I have product carbon footprint information"
                      />
                      <FormControlLabel
                        disabled={!!emissionsData}
                        value="allocation"
                        control={<Radio />}
                        label="Allocation approach"
                      />
                      <FormControlLabel
                        disabled={!!emissionsData}
                        value="none"
                        control={<Radio />}
                        label="I don't want to follow the above mentioned approach"
                      />
                    </RadioGroup>

                    {formData.approachMethod == "allocation" ? (
                      <div style={{ marginTop: "30px" }}>
                        <Select
                          disabled={!!emissionsData}
                          onChange={(e) => {
                            setAllocationApproach(e.target.value);
                          }}
                          sx={{
                            width: "35%",
                            fontSize: "0.9rem",
                            borderRadius: "10px",
                          }}
                          value={formData.allocationApproach}
                        >
                          <MenuItem value={"production volume"}>
                            Production Volume approach
                          </MenuItem>
                          <MenuItem value={"fixed percentage"}>
                            Allocate by fixed percentage
                          </MenuItem>
                          <MenuItem value={"economic"}>Economic</MenuItem>
                        </Select>
                        {formData.allocationApproach == "production volume" ? (
                          <div
                            className="flex gap-x-20"
                            style={{ marginTop: "30px" }}
                          >
                            <div className="flex flex-col w-2/5">
                              <span className="pw-input-label">
                                Total Production
                              </span>
                              <OutlinedInput
                                disabled={!!emissionsData}
                                value={formData.totalProduction}
                                onChange={handleTotalProduction}
                              />
                            </div>
                            <div className="flex flex-col w-2/5">
                              <span className="pw-input-label">Supplied</span>
                              <OutlinedInput
                                disabled={!!emissionsData}
                                value={formData.suppliedCount}
                                onChange={handlesuppliedCount}
                              />
                            </div>
                          </div>
                        ) : formData.allocationApproach ==
                          "fixed percentage" ? (
                          <div className="flex flex-col w-2/5">
                            <span className="pw-input-label">
                              Allocated percentage
                            </span>
                            <OutlinedInput
                              value={formData.allocatedPercentage}
                              disabled={!!emissionsData}
                              onChange={handleAllocatedPercentage}
                            />
                          </div>
                        ) : formData.allocationApproach === "economic" ? (
                          <div
                            className="flex gap-x-20"
                            style={{ marginTop: "30px" }}
                          >
                            <div className="flex flex-col w-2/5">
                              <span className="pw-input-label">
                                Total revenue
                              </span>
                              <OutlinedInput
                                disabled={!!emissionsData}
                                value={formData.totalRevenue}
                                onChange={handleRevenue}
                              />
                            </div>
                            <div className="flex flex-col w-2/5">
                              <span className="pw-input-label">Sales</span>
                              <OutlinedInput
                                disabled={!!emissionsData}
                                value={formData.sales}
                                onChange={handleSales}
                              />
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div style={{ marginTop: "30px" }}>
                          <Table>
                            <TableHead sx={{ backgroundColor: "#FAFBFD" }}>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Total emissions</TableCell>
                                <TableCell>Scope 1</TableCell>
                                <TableCell>Scope 2</TableCell>
                                <TableCell>Scope 3</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>Emissions</TableCell>
                                <TableCell>{formData.totalEmissions}</TableCell>
                                <TableCell>{formData.totalScope1}</TableCell>
                                <TableCell>{formData.totalScope2}</TableCell>
                                <TableCell>{formData.totalScope3}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>Allocated emissions</TableCell>
                                <TableCell sx={{ backgroundColor: "#FDF8E8" }}>
                                  {formData.allocatedTotalEmissions}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#FDF8E8" }}>
                                  {formData.allocatedScope1}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#FDF8E8" }}>
                                  {formData.allocatedScope2}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#FDF8E8" }}>
                                  {formData.allocatedScope3}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </div>
                      </div>
                    ) : formData.approachMethod == "product" ? (
                      <>
                        <div style={{ marginTop: "30px" }}>
                          <Table>
                            <TableHead sx={{ backgroundColor: "#FAFBFD" }}>
                              <TableRow>
                                <TableCell>Product</TableCell>
                                <TableCell>
                                  Emission factor value per unit(t Co2e)
                                </TableCell>
                                <TableCell>Total number of units</TableCell>
                                <TableCell>Emission(t Co2e)</TableCell>
                                <TableCell></TableCell>
                                <TableCell>Comments</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {formData.productTransactions.map(
                                (transaction: any, index: number) => {
                                  return (
                                    <TableRow>
                                      <TableCell sx={{ width: "25%" }}>
                                        {" "}
                                        <Input
                                          disabled={!!emissionsData}
                                          onChange={(e) =>
                                            handleTransactionTextInput(
                                              transaction,
                                              e.target.value,
                                              "fieldName"
                                            )
                                          }
                                          value={transaction.fieldName}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ width: "25%" }}>
                                        <Input
                                          disabled={!!emissionsData}
                                          onChange={(e) =>
                                            handleEmissionFactor(transaction, e)
                                          }
                                          value={transaction.emissionFactor}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ width: "20%" }}>
                                        <Input
                                          disabled={!!emissionsData}
                                          onChange={(e) =>
                                            handleTotalUnits(transaction, e)
                                          }
                                          value={transaction.totalUnits}
                                        />
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          backgroundColor: "#FDF8E8",
                                          width: "20%",
                                        }}
                                      >
                                        <Input
                                          disabled={!!emissionsData}
                                          value={transaction.value}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        {" "}
                                        <label
                                          className="pw-cursor-pointer"
                                          htmlFor={"product" + index}
                                        >
                                          <Badge
                                            onClick={(e) =>
                                              openAttachments(transaction)
                                            }
                                            anchorOrigin={{
                                              vertical: "bottom",
                                              horizontal: "right",
                                            }}
                                            className={
                                              transaction.attachments.length
                                                ? "pw-badge-primary"
                                                : "pw-badge-disabled"
                                            }
                                            badgeContent={<AddIcon />}
                                          >
                                            <AttachFileIcon />
                                          </Badge>
                                        </label>
                                        {/* <input
                                      disabled={!!emissionsData}
                                      multiple
                                      className="hidden"
                                      onChange={(e) =>
                                        openAttachments(e, transaction)
                                      }
                                      id={"product" + index}
                                      type="file"
                                    /> */}
                                      </TableCell>
                                      <TableCell>
                                        <Input
                                          disabled={!!emissionsData}
                                          onChange={(e) =>
                                            handleTransactionTextInput(
                                              transaction,
                                              e.target.value,
                                              "comments"
                                            )
                                          }
                                          value={transaction.comments}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}
                            </TableBody>
                          </Table>
                          <Button
                            onClick={(e) => {
                              addNewProduct();
                            }}
                            variant="contained"
                            sx={{
                              cursor: "pointer",
                              color: "white",
                              marginTop: "10px",
                            }}
                          >
                            Add row
                          </Button>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div
                    style={{
                      padding: "30px",
                      background: "white",
                      borderRadius: "5px",
                    }}
                  >
                    <FormGroup>
                      {investmentCategories.map((item, index) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled={!!emissionsData}
                                checked={selectedInvestmentCategories[item]}
                                onChange={(e) =>
                                  handleAllocationCategoryCheck(item, index, e)
                                }
                              />
                            }
                            label={item}
                          />
                        );
                      })}
                    </FormGroup>

                    {formData.investorAllocations.map(
                      (item: any, index: any) => {
                        return (
                          <div
                            style={{
                              padding: "30px 30px 30px 10px",
                              background: "white",
                              borderRadius: "5px",
                            }}
                          >
                            <div>
                              <strong>{item.name}</strong>
                            </div>
                            <div style={{ marginTop: "30px" }}>
                              <Select
                                disabled={!!emissionsData}
                                onChange={(e) => {
                                  setInvestorAllocationApproach(
                                    e.target.value,
                                    index
                                  );
                                }}
                                sx={{
                                  width: "35%",
                                  fontSize: "0.9rem",
                                  borderRadius: "10px",
                                }}
                                value={
                                  formData.investorAllocations[index]
                                    .allocationMethod
                                }
                              >
                                <MenuItem value={"fixed attribution factor"}>
                                  Fixed Attribution Factor
                                </MenuItem>
                                <MenuItem value={"outstanding value based"}>
                                  Outstanding Value-Based Allocation
                                </MenuItem>
                              </Select>
                              {formData.investorAllocations[index]
                                .allocationMethod ==
                              "outstanding value based" ? (
                                <div
                                  className="flex gap-x-20"
                                  style={{ marginTop: "30px" }}
                                >
                                  <div className="flex flex-col w-2/5">
                                    <span className="pw-input-label">
                                      Total Enterprise Value
                                    </span>
                                    <OutlinedInput
                                      disabled={!!emissionsData}
                                      value={
                                        formData.investorAllocations[index]
                                          .denominator
                                      }
                                      onChange={(e) =>
                                        handleInvestorDenominator(e, index)
                                      }
                                    />
                                  </div>
                                  <div className="flex flex-col w-2/5">
                                    <span className="pw-input-label">
                                      Outstanding Amount
                                    </span>
                                    <OutlinedInput
                                      disabled={!!emissionsData}
                                      value={
                                        formData.investorAllocations[index]
                                          .numerator
                                      }
                                      onChange={(e) =>
                                        handleInvestorNumerator(e, index)
                                      }
                                    />
                                  </div>
                                </div>
                              ) : formData.investorAllocations[index]
                                  .allocationMethod ==
                                "fixed attribution factor" ? (
                                <div className="flex flex-col w-2/5">
                                  <span className="pw-input-label">
                                    Fixed Attribution Factor
                                  </span>
                                  <OutlinedInput
                                    value={
                                      formData.investorAllocations[index]
                                        .allocatedPercentage
                                    }
                                    disabled={!!emissionsData}
                                    onChange={(e) =>
                                      handleInvestorAllocatedPercentage(
                                        e,
                                        index
                                      )
                                    }
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                              <div style={{ marginTop: "30px" }}>
                                <Table>
                                  <TableHead
                                    sx={{ backgroundColor: "#FAFBFD" }}
                                  >
                                    <TableRow>
                                      <TableCell></TableCell>
                                      <TableCell>Total emissions</TableCell>
                                      <TableCell>Scope 1</TableCell>
                                      <TableCell>Scope 2</TableCell>
                                      <TableCell>Scope 3</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell>Emissions</TableCell>
                                      <TableCell>
                                        {formData.totalEmissions}
                                      </TableCell>
                                      <TableCell>
                                        {formData.totalScope1}
                                      </TableCell>
                                      <TableCell>
                                        {formData.totalScope2}
                                      </TableCell>
                                      <TableCell>
                                        {formData.totalScope3}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell>Allocated emissions</TableCell>
                                      <TableCell
                                        sx={{ backgroundColor: "#FDF8E8" }}
                                      >
                                        {
                                          formData.investorAllocations[index]
                                            .allocatedTotalEmissions
                                        }
                                      </TableCell>
                                      <TableCell
                                        sx={{ backgroundColor: "#FDF8E8" }}
                                      >
                                        {
                                          formData.investorAllocations[index]
                                            .allocatedScope1
                                        }
                                      </TableCell>
                                      <TableCell
                                        sx={{ backgroundColor: "#FDF8E8" }}
                                      >
                                        {
                                          formData.investorAllocations[index]
                                            .allocatedScope2
                                        }
                                      </TableCell>
                                      <TableCell
                                        sx={{ backgroundColor: "#FDF8E8" }}
                                      >
                                        {
                                          formData.investorAllocations[index]
                                            .allocatedScope3
                                        }
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </TabPanel>
              </TabContext>
            </>
          ) : (
            ""
          )}
        </div>

        <div
          className="fixed flex justify-end items-center bg-white bottom-0"
          style={{
            height: "70px",
            width: "-webkit-fill-available",
            fontFamily: "Roboto",
            paddingRight: "5vw",
            boxShadow: "0px -5px 5px -5px rgb(128,128,128)",
            zIndex: 1,
          }}
        >
          <div className="flex flex-row gap-x-8 pw-submit-bar">
            <Button onClick={handleCancel}>Cancel</Button>
            {COLLECTION_STEPS.ALLOCATION_APPROACH == step ? (
              <Button onClick={() => setStep(COLLECTION_STEPS.EMISSIONS)}>
                Back
              </Button>
            ) : (
              ""
            )}
            <div style={{ color: "white", display: "flex" }}>
              <div
                onClick={(e) =>
                  COLLECTION_STEPS.EMISSIONS == step
                    ? handleNext()
                    : handleSubmit()
                }
                style={{
                  background:
                    COLLECTION_STEPS.ALLOCATION_APPROACH == step
                      ? !!emissionsData
                        ? neutral[400]
                        : primaryColor
                      : primaryColor,
                  display: "flex",
                  padding: "10px 25px",
                  borderTopLeftRadius: "5px",
                  alignItems: "center",
                  fontSize: "1.1rem",
                  borderBottomLeftRadius: "5px",
                  fontWeight: "700",
                  cursor:
                    COLLECTION_STEPS.ALLOCATION_APPROACH == step
                      ? !!emissionsData
                        ? "default"
                        : "pointer"
                      : "pointer",
                }}
              >
                {COLLECTION_STEPS.EMISSIONS == step ? "Next" : "Save"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={showFileUpload}
        onClose={handleClose}
        className="pw-attachment-dialog"
      >
        <div className="pb-6">
          <div className="pw-header-text">Add attachments</div>
          <div
            onClick={handleClose}
            style={{
              cursor: "pointer",
              textAlign: "right",
              marginTop: "-30px",
              // padding: "10px",
            }}
          >
            <CancelIcon />
          </div>
          <FileAttachmentsDetails
            formData={currentAttachmentForm}
            setFormData={(formData: any) =>
              handleFileUpload(formData.attachments)
            }
          ></FileAttachmentsDetails>
        </div>
      </Dialog>
      {showWarning || showPreferenceWarning ? (
        <Dialog open={openWarningDialog}>
          <DialogContent>
            <DialogContentText>{dialogWarningText}</DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => {
                setOpenWarningDialog(false);
              }}
              sx={{ color: "red" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                {
                  setOpenWarningDialog(false);
                  if (dialogWarningText == DIALOG_WARNING_TEXT.EMISSIONS) {
                    setShowWarning(false);
                  } else {
                    setShowPreferenceWarning(false);
                  }
                }
              }}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        ""
      )}
    </div>
  );
}
